import { H1 } from '#app/components/typography/h1.tsx'
import { P } from '#app/components/typography/p.tsx'

export default function ComponentsRoute() {
	return (
		<div>
			<H1>Components</H1>
			<P className="text-muted-600 mt-8">This is the component section. You can find all the low-level components of VerveUI here.</P>
		</div>
	)
}
